import React, { Component } from 'react';

class DataTable extends Component {
    render() {
        return (
            <tr>
                <td>
                    {this.props.obj.id_nota}
                </td>
                <td>
                    {this.props.obj.nota}
                </td>
                <td>
                    {this.props.obj.id_nota}
                </td>
            </tr>
        );
    }
}

export default DataTable;